import Header from "components/Header";
import { routes } from "constants/routes";
import MainLayout from "layouts/Main";
import CreateFundingRequest from "../modules/CreateFundingRequest";

export default function CreateDirectFR() {
  return (
    <MainLayout
      desktopTitle="Create Funding Request"
      customHeader={
        <Header label="Create Funding Request" goBackPath={routes.HAULPAY_BROKER_MANAGE_PAY} />
      }
      className="px-5">
      <CreateFundingRequest />
    </MainLayout>
  );
}
